import { HttpInterface } from "shared";

export const Api = new HttpInterface({
  withCredentials: true,
});

Api.http.interceptors.request.use((req) => {
  req.headers.set(
    "X-Time-Zone",
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  return req;
});
